import { Navigate } from "react-router-dom";

export default function OperatorRoute({ isOperatorLoggedIn, children }) {
    if (!isOperatorLoggedIn) {
        return <Navigate to="/OperatorLogin" replace />;
    }
    return children;
}
